import React from 'react';

import { TestDialog } from '@/components/flow-canvas/components/side-menu/test-dialog';
import { SuccessScreenComponentProps } from '@/hooks/useTestFlow';
import { Button, ButtonVariant } from '@/ui-library';
import { TestFlowStatus } from '@/utils/types/test-flow.types';

const MESSAGES = {
  WARNING_TITLE: 'Your flow executed properly, but...',
  WARNING_MESSAGE: 'No orders were found. Try to modify the search parameters and run the flow again.',
  SUCCESS_TITLE: "We've retrieved the order",
  SUCCESS_SUBTITLE: 'Here you can find the details:',
} as const;

const WarningView: React.FC<{ onCancel: () => void }> = ({ onCancel }) => (
  <>
    <h2 className='text-NeutralDarkDarkest text-base not-italic font-black mb-5' role='alert'>
      {MESSAGES.WARNING_TITLE}
    </h2>
    <div className='flex flex-col gap-2 justify-center mb-8'>
      <p className='text-NeutralDarkLight mb-3'>{MESSAGES.WARNING_MESSAGE}</p>
      <div className='w-full flex gap-2 justify-center'>
        <Button variant={ButtonVariant.Secondary} onClick={onCancel}>
          Got it
        </Button>
      </div>
    </div>
  </>
);

const SuccessView: React.FC<{
  data: unknown;
  onCancel: () => void;
  onConfirm: () => void;
}> = ({ data, onCancel }) => (
  <>
    <h2 className='text-NeutralDarkDarkest text-base not-italic font-black mb-2'>{MESSAGES.SUCCESS_TITLE}</h2>
    <p className='text-NeutralDarkDark mb-5 text-sm'>{MESSAGES.SUCCESS_SUBTITLE}</p>
    <TestDialog.Data data={data ? JSON.stringify(data) : ''} />
    <div className='w-full flex gap-2 justify-center mt-6'>
      <Button variant={ButtonVariant.Primary} onClick={onCancel}>
        Confirm
      </Button>
    </div>
  </>
);

export const GetCurrentStatusByOrderId: React.FC<SuccessScreenComponentProps> = ({
  data,
  onCancel,
  onConfirm,
  status,
}) => {
  const emailData = data;

  return status === TestFlowStatus.WARNING ? (
    <WarningView onCancel={onCancel} />
  ) : (
    <SuccessView data={emailData} onCancel={onCancel} onConfirm={() => onConfirm()} />
  );
};
